module.exports = __webpack_public_path__ + "img/real-dyn.81ece2a9.svg";